/** @flow */

import getElementoPorId from '../../utils/get-elemento-por-id';

const mostrar = () => {
    getElementoPorId('container-graficos').style.display = 'none';
    getElementoPorId('container-grafico-horas').style.display = 'block';
    getElementoPorId('container-grafico-dia-da-semana').style.display = 'block';
    getElementoPorId('container-grafico-dias').style.display = 'block';
};

export default mostrar;
